import React, { useEffect, useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import publicApi from "@/lib/publicApi";
import { PublicNav } from "@/components/public/PublicNav";
import { PublicFooter } from "@/components/public/PublicFooter";
import { StickyMobileFooter } from "@/components/StickyMobileFooter";
import { ChatWidget } from "@/components/public/ChatWidget";
import { WelcomeVideo } from "@/components/public/WelcomeVideo";
import { Loader2 } from "lucide-react";

const telHref = (phone) => `tel:${(phone || "").replace(/[^0-9+]/g, "")}`;

export default function PublicLayout() {
  const [content, setContent] = useState(null);
  const [nav, setNav] = useState([]);
  const [footerMenu, setFooterMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [chatOpen, setChatOpen] = useState(false);
  const [chatPrefill, setChatPrefill] = useState(null);
  const [welcomeOpen, setWelcomeOpen] = useState(false);

  const openChat = useCallback((prefill = null) => {
    setChatPrefill(prefill);
    setChatOpen(true);
  }, []);

  const openWelcomeVideo = useCallback(() => setWelcomeOpen(true), []);

  const load = useCallback(async () => {
    try {
      const { data } = await publicApi.get("/public/homepage");
      setContent(data.content);
      setNav(data.nav || []);
      setFooterMenu(data.footer_menu || []);
    } catch (e) {
      setContent({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFDFE]">
        <Loader2 className="animate-spin text-[#1C4358]" size={32} />
      </div>
    );
  }

  const phone = content?.phone;

  return (
    <div className="public-site min-h-screen flex flex-col bg-[#FDFDFE] text-[#252221]">
      <PublicNav nav={nav} phone={phone} />
      <main className="flex-1">
        <Outlet context={{ content, nav, openChat, openWelcomeVideo }} />
      </main>
      <PublicFooter footer={content?.footer || {}} footerMenu={footerMenu} phone={phone} />
      <div className="h-[60px] lg:hidden" aria-hidden />
      <StickyMobileFooter
        variant="fixed"
        phone={telHref(phone)}
        consultationHref="/book"
        onChat={() => openChat({ cta_source: "Sticky Footer Chat" })}
        facebookHref={content?.footer?.facebook_url || undefined}
        showLogin={!content?.footer?.facebook_url}
      />
      <ChatWidget open={chatOpen} onOpenChange={setChatOpen} prefill={chatPrefill} content={content} />
      <WelcomeVideo content={content} open={welcomeOpen} onOpenChange={setWelcomeOpen} />
    </div>
  );
}
